import React from 'react';
import { QboSpinnerProgress } from '@ui/Components';
import useUserAuthenticate from './pageHooks/useUserAuthenticate';

export default function SSOPage() {
  useUserAuthenticate();
  return <QboSpinnerProgress fullWrapper />;
}
